import React from 'react';
import LoadingSpinner from '../../Common/LoadingSpinner';

/**
 * Canonical Events-module loading indicator.
 * Same indigo spinner as Judges / Submissions list pages.
 *
 * variant:
 * - page    — full-page first load
 * - section — centered spinner + message for panels, modals, tables (default)
 * - inline  — compact row for nested lists / settings cards
 * - overlay — spinner only, for dimmed overlays
 */
export default function EventLoadingState({
  message = 'Loading...',
  variant = 'section',
  className = '',
}) {
  if (variant === 'page') {
    return <LoadingSpinner message={message} className={className} />;
  }

  if (variant === 'overlay') {
    return (
      <LoadingSpinner
        inline
        size="lg"
        showMessage={false}
        color="text-indigo-600"
      />
    );
  }

  if (variant === 'inline') {
    return (
      <div className={`flex items-center justify-center gap-2 py-3 ${className}`.trim()} role="status" aria-live="polite">
        <LoadingSpinner inline size="sm" showMessage={false} center={false} color="text-indigo-600" />
        {message ? <span className="text-sm text-gray-600">{message}</span> : null}
      </div>
    );
  }

  return (
    <div className={`flex flex-col items-center justify-center py-12 px-4 ${className}`.trim()} role="status" aria-live="polite">
      <LoadingSpinner inline size="lg" showMessage={false} color="text-indigo-600" />
      {message ? <p className="mt-3 text-sm text-gray-600">{message}</p> : null}
    </div>
  );
}
